module.exports = __webpack_public_path__ + "media/images/icons/outlined/sort-descending-40f236dd128ff3d20a3898cfb86f12e2.svg";